
import React, { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";
import { dataCollector } from '@/services/fraudDetection/ml/dataCollector';
import { 
  StatsCards, 
  FeatureCoverageCard, 
  FeatureImportanceChart,
  LoadingState 
} from './ml-dashboard';

export function MLTrainingDashboard() {
  const [stats, setStats] = useState<any>(null);
  const [featureImportance, setFeatureImportance] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    setIsLoading(true);
    try {
      const trainingStats = await dataCollector.getTrainingStats();
      setStats(trainingStats);
      
      const featureData = await dataCollector.analyzeFeatureImportance();
      setFeatureImportance(featureData);
    } catch (error) {
      console.error("Error loading training data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleRefresh = () => {
    setIsLoading(true);
    Promise.all([
      dataCollector.getTrainingStats(),
      dataCollector.analyzeFeatureImportance()
    ]).then(([statsData, featureData]) => {
      setStats(statsData);
      setFeatureImportance(featureData);
      setIsLoading(false);
    }).catch(error => {
      console.error("Error refreshing data:", error);
      setIsLoading(false);
    });
  };

  if (isLoading) {
    return <LoadingState />;
  }

  return (
    <div className="space-y-6">
      <StatsCards stats={stats} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FeatureCoverageCard featureCoverage={stats?.featureCoverage} />
        <FeatureImportanceChart featureImportance={featureImportance} />
      </div>

      <div className="flex justify-end">
        <Button 
          onClick={handleRefresh}
          disabled={isLoading}
        >
          Refresh Data
        </Button>
      </div>
    </div>
  );
}
